<template>
    <div class="relatorio-analitico">
        <RelatorioAnaliticoComponentList
            app_modulo="promotor"
            app_submodulo="relatorio-analitico"
            app_tela="relatorio-pro-vencimento"
            :objectList="vencimentoList"
            :objectListAll="vencimentoListAll"
            :isEmpty="isEmpty"
            :isLoading="isLoading"
            :isDataStarted="isDataStarted"
            :pagination="pagination"
            :tooltipLabelSearch="
                $t('msg-campo-busca-n', {
                    n: `${$t('codigo')}, ${$t('produto')}, ${$t('lote')}, ${$t('rsocial')} e ${$t(
                        'nome'
                    )} (${$t('cliente')} e ${$t('lps')})`,
                })
            "
            showLateralFilter
            :cameFrom="cameFrom"
            @filtersReset="filtersReset = $event"
            @loadedFiels="loadedFiels = $event"
            @carregarDados="carregarDados($event)"
            @carregarDadosExportAll="carregarDados($event, true)"
            @search="onSearch($event)"
            @clearFilter="clearFilter()"
            @orderColumn="pagination.orderColumn = $event"
            @orderDirection="pagination.orderDirection = $event"
            @perPage="pagination.perPage = $event"
            @currentPage="pagination.currentPage = $event"
            @isLoading="isLoading = $event"
            @voltar="$emit('voltar', $event)"
        >
            <template v-slot:top-filter>
                <vss-select
                    title="empresa"
                    ref="empresaSelect"
                    class="smaller"
                    :value="empresaSelected"
                    :options="empresaList"
                    :height="40"
                    :loading="empresaLoading"
                    @search="carregarEmpresas"
                    @input="updateEmpresa"
                    label="rsocial"
                    :closeOnSelect="false"
                    no-clearfix
                    multiple
                    clearable
                    searchable
                >
                    <template #multiple-selected="{ selected }">
                        ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                    </template>
                </vss-select>
                <vss-select
                    title="colaborador"
                    ref="colaboradorSelect"
                    class="smaller"
                    :value="colaboradorSelected"
                    :options="colaboradorList"
                    :height="40"
                    :loading="colaboradorLoading"
                    @search="carregarColaboradores"
                    @input="updateColaborador"
                    label="nome"
                    :closeOnSelect="false"
                    no-clearfix
                    multiple
                    clearable
                    searchable
                    tooltipLabel="msg-associacao-empresa-colaborador"
                >
                    <template #multiple-selected="{ selected }">
                        ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                    </template>
                </vss-select>
            </template>

            <template v-slot:table-column="{ props, field }">
                <div v-if="field.key === 'foto'">
                    <div @click="props.row.foto ? showFotosModal(props.row.id) : null">
                        <b-icon
                            :class="{ 'is-clickable': props.row.foto }"
                            pack="fas"
                            icon="image"
                            :type="props.row.foto ? 'is-primary' : 'is-gray'"
                        />
                    </div>
                </div>
                <div v-else>
                    {{ isNull(props.row[field.key]) ? '---' : props.row[field.key] }}
                </div>
            </template>

            <template v-slot:lateral-filter>
                <FiltroVencimento
                    ref="filtroRef"
                    :filtersReset="filtersReset"
                    @update-filtro="updateFiltro"
                />
            </template>
        </RelatorioAnaliticoComponentList>
        <lateral-content
            :title="$t('fotos')"
            :isLoading="isLoadingFotos"
            v-model="showFotos"
            v-if="showFotos"
            header
        >
            <LateralContentFoto :fotosToDisplay="fotosToDisplay" />
        </lateral-content>
    </div>
</template>

<script>
import RelatorioAnaliticoComponentList from '@/components/shared/tela/RelatorioAnaliticoComponentList.vue';
import FiltroVencimento from '@/components/promotor/relatorio-analitico/relatorio-vencimento/RelatorioVencimentoListFiltro.vue';
import LateralContentFoto from '@/components/shared/tela/LateralContentFoto.vue';

export default {
    components: {
        RelatorioAnaliticoComponentList,
        FiltroVencimento,
        LateralContentFoto,
    },
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        idFrom: {
            type: Number,
            default: 0,
        },
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            vencimentoList: [],
            vencimentoListAll: [],

            filtros: {
                idEmpresaList: [],
                idVendedorList: [],
                dataInicial: new Date(this.$moment().subtract(30, 'days')),
                dataFinal: new Date(),
                dataValidadeInicial: new Date(this.$moment().subtract(30, 'days')),
                dataValidadeFinal: new Date(),
                idClienteList: [],
                idLpsList: [],
                idProdutoList: [],
                withFoto: 0,
            },

            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
                orderColumn: 'idatendimentorupturaerp',
                orderDirection: 'desc',
                queryFilter: '.*',
            },

            empresaList: [],
            empresaSelected: [],
            empresaLoading: false,

            colaboradorList: [],
            colaboradorSelected: [],
            colaboradorLoading: false,

            isLoading: false,
            loadedFiels: false,

            isEmpty: true,
            filtersReset: false,

            showFotos: false,
            isLoadingFotos: false,
            fotosToDisplay: [],
            isDataStarted: false,
        };
    },
    watch: {
        reloadData(val) {
            if (val) this.carregarDados(this.pagination.currentPage);
        },
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
    },
    methods: {
        onSearch(value) {
            this.pagination.queryFilter = value;
            this.carregarDados();
        },
        carregarDados(currentPage = 1, getAll = false) {
            if (!getAll && currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            if (!getAll) this.vencimentoListAll = [];

            this.isLoading = true;
            this.$axios
                .post(`pro/relatorio/vencimento/list.json`, this.filtros, {
                    params: {
                        column: this.pagination.orderColumn,
                        order: this.pagination.orderDirection,
                        page: currentPage - 1,
                        limit: getAll ? this.pagination.totalRows : this.pagination.perPage,
                        search: this.pagination.queryFilter,
                    },
                })
                .then((response) => {
                    if (!getAll) {
                        this.isEmpty = response.data.totalElements == 0;
                        this.pagination.totalRows = response.data.totalElements;
                    }

                    return response.data.content.map((obj) => ({
                        ...obj,
                        cliente_situacao:
                            obj.cliente_situacao === 3 ? this.$t('ativo') : this.$t('inativo'),
                        lps_situacao:
                            obj.lps_situacao === 3 ? this.$t('ativo') : this.$t('inativo'),
                        datavalidade: this.$moment(obj.datavalidade).format('L'),
                        datahora: this.$moment(obj.datahora).format('L LT'),
                    }));
                })
                .then((mappedContent) => {
                    if (getAll) {
                        this.vencimentoListAll = mappedContent;
                    } else {
                        this.vencimentoList = mappedContent;
                    }
                })
                .catch(() => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally(() => {
                    if (!getAll) this.pagination.resetPagination = false;
                    this.isDataStarted = true;
                    if (this.loadedFiels) this.isLoading = false;
                });
        },
        verifyFieldsByTipoCampo(field, tipoCampo) {
            const DEFAULT_VALUE = '---';

            if (field === '-1') {
                return DEFAULT_VALUE;
            }

            // tipoCampo 1 corresponde a RADIO - não (0) ou sim (1)
            if (tipoCampo === 1) {
                const radioOptions = {
                    1: this.$t('sim'),
                    0: this.$t('nao'),
                };

                return radioOptions[field] || field;
            } else {
                // Handle EDIT
                return field || DEFAULT_VALUE;
            }
        },

        sumQtdeTotalizers(qtde, field) {
            const isValid = !this.isNull(field) && !this.isNull(qtde);
            const fieldNumber = Number(field);
            const fieldQtde = Number(qtde);
            let value = fieldQtde;

            if (isValid) {
                if (fieldNumber === 1) {
                    value = fieldQtde + 1;
                } else if (fieldNumber > 1) {
                    value = fieldQtde + fieldNumber;
                }
            }

            return value;
        },
        carregarEmpresas(search = '') {
            this.empresaLoading = true;
            this.$axios
                .get(`/vendas/empresa/list.json?param=${search}`)
                .then((response) => {
                    this.empresaList = response.data.content.map((e) => {
                        return {
                            id: e.idempresa,
                            rsocial: e.rsocial,
                        };
                    });
                })
                .catch(() => {
                    this.empresaList = [];
                })
                .finally(() => {
                    this.empresaLoading = false;
                });
        },
        updateEmpresa(empresa) {
            this.empresaSelected = empresa;

            this.colaboradorSelected = [];
            this.colaboradorList = [];

            this.filtros.idEmpresaList =
                this.empresaSelected.length == 0 ? [] : this.empresaSelected.map((e) => e.id);

            this.carregarColaboradores('');
            this.carregarDados();
        },
        carregarColaboradores(search = '') {
            this.colaboradorLoading = true;

            const empresa =
                this.empresaSelected.length > 0 ? this.empresaSelected.map((e) => e.id) : [];

            this.$axios
                .post(`/employees/list/associacaoidsempresa.json?search=${search}`, empresa)
                .then((response) => {
                    this.colaboradorList = response.data.content;
                })
                .catch(() => {
                    this.empresaList = [];
                })
                .finally(() => {
                    this.colaboradorLoading = false;
                });
        },
        updateColaborador(colaborador) {
            this.colaboradorSelected = colaborador;

            this.filtros.idVendedorList =
                this.colaboradorSelected.length == 0
                    ? []
                    : this.colaboradorSelected.map((e) => e.id);

            this.carregarDados();
        },
        clearFilter() {
            this.pagination.queryFilter = '.*';

            this.filtros.idEmpresaList = [];
            this.empresaSelected = [];

            this.filtros.idVendedorList = [];
            this.colaboradorSelected = [];

            this.filtros.dataInicial = new Date(this.$moment().subtract(30, 'days'));
            this.filtros.dataFinal = new Date();
            this.filtros.dataValidadeInicial = new Date(this.$moment().subtract(30, 'days'));
            this.filtros.dataValidadeFinal = new Date();
            this.filtros.idClienteList = [];
            this.filtros.idLpsList = [];
            this.filtros.idProdutoList = [];
            this.filtros.withFoto = 0;

            setTimeout(() => {
                this.carregarDados();
            }, 1000);
        },
        updateFiltro(filtro) {
            this.filtros[filtro.nomeFiltro] = filtro.valor;
        },
        showFotosModal(idVencimento) {
            this.isLoadingFotos = true;

            this.fotosToDisplay = [];

            this.$axios
                .get(`pro/relatorio/vencimento/${idVencimento}/fotos.json`)
                .then((response) => {
                    this.fotosToDisplay = response.data.content;
                })
                .catch((error) => {
                    console.error('Erro ao carregar fotos.', error);
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => (this.isLoadingFotos = false));

            this.showFotos = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.relatorio-analitico {
    height: 100%;
}
</style>
